import { useEffect } from 'react';
import { Modal, ModalContent } from '@components/Modal';
import { IntegrationType } from '@insights_module/types/Integrations';
import { useIntegrationsContext } from '@insights_module/context/IntegrationsContext';
import { useIntegrationTags } from '@insights_module/hooks/useIntegrationTags';
import { useSegmentCreatorContext } from '@insights_module/context/SegmentCreatorContext';
import { EditTagForm } from '@insights_module/components/integrations/EditTagForm';
import { INTEGRATION_TYPE } from '@insights_module/constants/integrations';

export const EditTagModal = ({ type }: { type: IntegrationType }) => {
  const { setSegmentsData } = useSegmentCreatorContext();
  const {
    searchTerm,
    isEditTagModalOpen,
    tagToEdit,
    setIsEditTagModalOpen,
    setTagToEdit,
    setType,
  } = useIntegrationsContext();
  const { getTagById } = useIntegrationTags(type, searchTerm);
  const selectedTag = getTagById(tagToEdit);

  const handleClose = () => {
    setTagToEdit(null);
    setSegmentsData([]);
    setIsEditTagModalOpen(false);
  };

  useEffect(() => {
    setType(type);
  }, []);

  if (!isEditTagModalOpen || !selectedTag || type === INTEGRATION_TYPE.MEGAPHONE) return null;

  return (
    <Modal onClose={handleClose}>
      <ModalContent className='mx-auto max-w-[1090px] overflow-y-scroll'>
        <EditTagForm type={type} />
      </ModalContent>
    </Modal>
  );
};
